import { EmergencyNotificationConfiguration } from '@dreryk/egabinet-emergency-notification-frontend-api';
import { PractitionerView } from '@dreryk/egabinet-personnel-frontend-api';

import { Bean, FormContextValues } from '@dreryk/react-common';
import { EmptyStatePlaceholder } from '@dreryk/react-components';

import {
   EmergencyNotificationInAppConfigurationResponseTeamPractitionersFieldFormBeanPart,
   EmergencyNotificationInAppConfigurationResponseTeamPractitionerValue,
} from '../EmergencyNotificationInAppConfigurationResponseTeamPractitionersField.types';
import { translationKeys } from '../../../../translations';

import { useEmergencyNotificationInAppConfigurationResponseTeamPractitionersInteractiveTableColumnConfigurationOptions } from './EmergencyNotificationInAppConfigurationResponseTeamPractitionersInteractiveTable.hooks';
import { StyledEmergencyNotificationInAppConfigurationResponseTeamPractitionersInteractiveTable } from './EmergencyNotificationInAppConfigurationResponseTeamPractitionersInteractiveTable.styled';
import { EmergencyNotificationInAppConfigurationResponseTeamPractitionersInteractiveTableSelector } from './EmergencyNotificationInAppConfigurationResponseTeamPractitionersInteractiveTableSelector';
import { EmergencyNotificationInAppConfigurationResponseTeamPractitionersInteractiveTableSynchronization } from './EmergencyNotificationInAppConfigurationResponseTeamPractitionersInteractiveTableSynchronization';

type EmergencyNotificationInAppConfigurationResponseTeamPractitionersInteractiveTableProps = Pick<
   FormContextValues<EmergencyNotificationInAppConfigurationResponseTeamPractitionersFieldFormBeanPart>,
   'register'
> & {
   readonly practitioners: PractitionerView[];
   readonly emergencyNotificationConfiguration: EmergencyNotificationConfiguration;
};

export const EmergencyNotificationInAppConfigurationResponseTeamPractitionersInteractiveTable = (
   props: EmergencyNotificationInAppConfigurationResponseTeamPractitionersInteractiveTableProps
): JSX.Element => {
   const columns = useEmergencyNotificationInAppConfigurationResponseTeamPractitionersInteractiveTableColumnConfigurationOptions();

   return (
      <StyledEmergencyNotificationInAppConfigurationResponseTeamPractitionersInteractiveTable<
         EmergencyNotificationInAppConfigurationResponseTeamPractitionerValue,
         Bean
      >
         name={'responseTeamPractitioners.value'}
         register={props.register}
         columns={columns}
         testId={'responseTeamPractitioners'}
         header={
            <EmergencyNotificationInAppConfigurationResponseTeamPractitionersInteractiveTableSelector
               practitioners={props.practitioners}
               register={props.register}
            />
         }
         placeholder={
            <EmptyStatePlaceholder
               heading={translationKeys.noResponseTeamPractitionersSelected}
               testId={'noResponseTeamPractitioners'}
            />
         }
      >
         <EmergencyNotificationInAppConfigurationResponseTeamPractitionersInteractiveTableSynchronization
            emergencyNotificationConfiguration={props.emergencyNotificationConfiguration}
            practitioners={props.practitioners}
         />
      </StyledEmergencyNotificationInAppConfigurationResponseTeamPractitionersInteractiveTable>
   );
};
